import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanTeamsRoute: InvariantJiraRoute = {
	name: 'software-plan-teams',
	path: '/jira/plans/:planId/scenarios/:scenarioId/teams',
};
